import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const changeContractStatus = createProvider(api.changeContractStatus).andThen((res) => res);
